'use client'
import Image from 'next/image'
import React, { Dispatch, SetStateAction, useCallback, useEffect } from 'react'
import styles from '../styles.module.scss'

interface FullScreenButtonProps {
  isFullScreen: boolean
  setFullScreen: Dispatch<SetStateAction<boolean>>
  image: string
}

const FullScreenButton = ({
  isFullScreen,
  setFullScreen,
  image,
}: FullScreenButtonProps) => {
  const handleFullScreenChange = useCallback(() => {
    if (!document.fullscreenElement) {
      setFullScreen(false)
      document.body.classList.remove('is-fullscreen')
    } else {
      document.body.classList.add('is-fullscreen')
    }
  }, [setFullScreen])

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange)
    }
    /*eslint-disable-next-line*/
  }, [])

  const onButtonClickHandler = useCallback(() => {
    setFullScreen(!isFullScreen)
    document.body.requestFullscreen()
    if (isFullScreen) {
      handleFullScreenChange()
    }
  }, [setFullScreen, isFullScreen, handleFullScreenChange])

  return (
    <button className={styles.button} onClick={onButtonClickHandler}>
      <Image unoptimized src={image} alt="progress" width={16} height={16} />
    </button>
  )
}

export default FullScreenButton
